module.exports = __webpack_public_path__ + "static/media/truck.00e45ba5.svg";